import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, UtensilsCrossed } from 'lucide-react';

export default function ArtikelEidFruehstueckIdeen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Frühstück Ideen: Das perfekte Festmahl zum Zuckerfest</h1>
          <p className="text-lg text-white/80 leading-relaxed">Traditionelle und moderne Rezeptideen für ein unvergessliches Eid-Frühstück mit der ganzen Familie.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Das Eid-Frühstück ist der Höhepunkt des Festes – nach einem Monat Fasten kommt die Familie zusammen, um gemeinsam zu essen, zu lachen und den Tag zu genießen. Hier findest du die besten Ideen für ein festliches Eid-Frühstück, das alle begeistert.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><UtensilsCrossed className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Traditionelle Klassiker</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Datteln & Milch</h4>
                <p className="text-sm text-[#4B5563]">Der traditionelle Start in den Eid-Tag: Medjool-Datteln mit einem Glas warmer Milch oder Laban. Einfach, symbolisch und nahrhaft – genau so, wie der Prophet (s.a.s.) das Fasten brach.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Fatayer & Börek</h4>
                <p className="text-sm text-[#4B5563]">Gefüllte Teigtaschen mit Spinat, Käse oder Fleisch – ein Klassiker der arabischen und türkischen Küche. Am Vorabend vorbereiten und morgens frisch backen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Ful Medames</h4>
                <p className="text-sm text-[#4B5563]">Ägyptisches Bohnengericht mit Olivenöl, Zitrone und Kreuzkümmel. Herzhaft, sättigend und perfekt mit frischem Fladenbrot.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Shakshuka</h4>
                <p className="text-sm text-[#4B5563]">Pochierte Eier in würziger Tomatensoße – ein nordafrikanischer Frühstücksklassiker, der auch in Deutschland immer beliebter wird. Serviert in der Pfanne mit Brot zum Dippen.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Süße Leckereien</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Maamoul-Kekse</h4>
                <p className="text-sm text-[#4B5563]">Die traditionellen gefüllten Kekse mit Datteln oder Walnüssen dürfen bei keinem Eid fehlen. Am besten schon einige Tage vorher backen – sie werden mit der Zeit noch besser.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Baklava</h4>
                <p className="text-sm text-[#4B5563]">Blätterteig-Schichten mit Nüssen und Honigsirup – ein Muss auf jeder festlichen Tafel. Tipp: Beim türkischen oder arabischen Bäcker bestellen oder selbst machen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Pancakes mit Dattelsirup</h4>
                <p className="text-sm text-[#4B5563]">Eine moderne Variante: Fluffige Pancakes mit Dattelsirup, Honig und frischen Beeren. Kinder lieben es!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Knafeh</h4>
                <p className="text-sm text-[#4B5563]">Palästinensisches Käsedessert mit Kadayif-Teig und Zuckersirup. Warm serviert ein absolutes Highlight.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Getränke zum Eid-Frühstück</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Arabischer Kaffee (Qahwa)</h4>
                <p className="text-sm text-[#4B5563]">Mit Kardamom gewürzter Kaffee in kleinen Finjan-Tassen – das Aroma füllt das ganze Haus und symbolisiert Gastfreundschaft.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Marokkanischer Minztee</h4>
                <p className="text-sm text-[#4B5563]">Frische Minze mit grünem Tee und Zucker – zeremoniell aus der Höhe eingegossen. Ein Erlebnis für alle Sinne.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Jallab</h4>
                <p className="text-sm text-[#4B5563]">Libanesisches Dattelgetränk mit Rosenwasser und Pinienkernen – erfrischend und festlich. Perfekt als alkoholfreier Willkommensdrink.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps für die perfekte Eid-Tafel</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Vorbereitung ist alles:</strong> So viel wie möglich am Vorabend vorbereiten, damit du morgens entspannt bist</li>
                <li><strong>Deko nicht vergessen:</strong> Frische Blumen, Dattel-Schalen und eine schöne Tischdecke machen den Unterschied</li>
                <li><strong>Kinderecke einrichten:</strong> Einen separaten Bereich mit kinderfreundlichem Essen und Eid-Tellern</li>
                <li><strong>Gastfreundschaft zeigen:</strong> Immer etwas extra vorbereiten – spontaner Besuch gehört zu Eid dazu</li>
                <li><strong>To-Go-Pakete:</strong> Kleine Tüten mit Süßigkeiten und Keksen für Besucher vorbereiten</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Zeitplan für den Eid-Morgen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Vor dem Eid-Gebet</h4>
                <p className="text-sm text-[#4B5563]">Leichtes Frühstück: Datteln, Milch, evtl. etwas Süßes. Das große Festessen kommt nach dem Gebet.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Nach dem Eid-Gebet (ca. 9-10 Uhr)</h4>
                <p className="text-sm text-[#4B5563]">Jetzt wird groß aufgetischt! Alles, was du am Vorabend vorbereitet hast, kann jetzt serviert werden.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Nachmittags</h4>
                <p className="text-sm text-[#4B5563]">Tee und Süßigkeiten für Besucher bereithalten. Baklava, Maamoul und frisches Obst.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Das Eid-Frühstück ist mehr als nur eine Mahlzeit – es ist ein Moment der Dankbarkeit und des Zusammenkommens. Ob traditionell oder modern, ob aufwändig oder schlicht: Hauptsache, die Familie ist vereint und das Herz ist fröhlich.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak und guten Appetit!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/halal-suessigkeiten-deutschland" className="text-[#4A5D4F] hover:underline">→ Halal Süßigkeiten in Deutschland</Link></li>
              <li><Link to="/ratgeber/eid-party-planen" className="text-[#4A5D4F] hover:underline">→ Eid Party planen: Der komplette Guide</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
